// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"53dd4c5f","431":"77696ead"}[chunkId] + ".chunk.js";
};